import { useEffect, useState } from "react";
import api from "@/lib/api";
import { BUSINESS } from "@/lib/location";

// Shared contact info — fetched once from the backend, BUSINESS (location.js) is the fallback
let cache = null;
let promise = null;
const listeners = new Set();

function load() {
    if (!promise) {
        promise = api
            .get("/api/content/contact")
            .then((res) => {
                if (res.data && res.data.phone) {
                    cache = res.data;
                    listeners.forEach((fn) => fn(cache));
                }
            })
            .catch(() => {});
    }
    return promise;
}

export function buildContact(raw) {
    const c = { ...BUSINESS, ...raw };
    const phoneDisplay = `+91 ${c.phone.slice(0, 5)} ${c.phone.slice(5)}`;
    const query = encodeURIComponent(`${c.name}, ${c.address}`);
    return {
        ...c,
        shortAddress: c.address.includes(", Near") ? `Near${c.address.split(", Near")[1]}` : c.address,
        phoneDisplay,
        telUrl: `tel:+91${c.phone}`,
        mailtoUrl: `mailto:${c.email}`,
        waLink: (msg) => `https://wa.me/91${c.phone}?text=${encodeURIComponent(msg)}`,
        whatsappUrl: `https://wa.me/91${c.phone}?text=${encodeURIComponent("Hi Work Island, I'd like to know more about your workspaces!")}`,
        googleMapsUrl: `https://www.google.com/maps/search/?api=1&query=${query}`,
        googleMapsDirectionsUrl: `https://www.google.com/maps/dir/?api=1&destination=${query}`,
        mapEmbedUrl: `https://www.google.com/maps?q=${query}&output=embed`,
    };
}

export function useContact() {
    const [contact, setContact] = useState(() => buildContact(cache || {}));
    useEffect(() => {
        const fn = (c) => setContact(buildContact(c));
        listeners.add(fn);
        load();
        return () => listeners.delete(fn);
    }, []);
    return contact;
}
